<template>
	<div class="conteudo-sistema" >
		<div class="fl-cabecalho">
			<div class="row animated slideInDown">
				<div class="col-6 form-group">
					<h4><fa-icon icon="compass" /> Locais</h4>
				</div>
			</div>

			<div class="row animated slideInDown">
				<div class="col-lg-4 col-md-4 form-group col-xs-4">
					<div class="btn-group btn-block btn-group-sm" role="group" aria-label="Basic example">
						<button v-for="(it, idx) in columnsBusca"
								@click="campoBusca = it.key"
								:key="idx"
								type="button"
								class="btn"
								:class="{'btn-primary' : it.key == campoBusca,
										'btn-outline-primary' : it.key != campoBusca}">
										{{it.title}}
						</button>
					</div>
				</div>

				<div class="col-lg-4 form-group col-md-10">
					<flFind @key-up="(inputText) => busca = inputText"
							textRight="Enter pra buscar"
							placeholder="Buscar"
							@keyup-enter="() => $refs.table.reseta()" />
				</div>

				<div class="col-12 col-xs-12 col-md-12 col-lg-2 form-group">
					<button @click="clickModal()" class="btn btn-block btn-sm btn-block btn-outline-dark">
						<fa-icon icon="plus"/> Novo
					</button>
				</div>

			</div>
		</div>
		<fl-table-server-side 	v-show="!load"
								ref="table"
								:perPage="500"
								@click-excluir="clickExcluir"
								@click-editar="editar"
								@carrega-dados="carregaDados"
								class="animated fadeIn fast"
								columnStartSortable="icao"
								:columns="geraCabecalhos()" />

		<flCarregando style="margin-top:20px" v-if="load" />

		<fl-modal ref="modalCadastro" @modal-hide="exibeModalCadastro = false" width="50%">
			<template v-slot:header>
				<span><fa-icon icon="plus"/> Novo</span>
			</template>
			<flModalCadastro v-if="exibeModalCadastro" ref="cadastro" @atualizar="atualizar" />
		</fl-modal>
	</div>
</template>
<script>
import flModal from '../../../components/modal/main.vue'
import flModalCadastro from './cadastro.vue'
import flIcon from '../../../components/fl-icon/main.vue'
import flCarregando from '../../../components/carregando/main.vue'
import axios from '../../../routers/axios'
import flTableServerSide from '../../../components/table-server-side/main.vue'
import flFind from '../../../components/find/main.vue'

export default {

	components: {
		flModal,
		flModalCadastro,
		flIcon,
		flCarregando,
		flTableServerSide,
		flFind
	},

	data() {
		return {

			exibeModalCadastro: false,

			load: false,

			busca: "",
			campoBusca: "icao",
			columnsBusca: [
				{ title: 'Designativo', key: 'icao' },
				{ title: 'IATA', key: 'iata' },
				{ title: 'Aeroporto', key: 'nome'},
				{ title: 'Cidade', key: 'cidade' },
				{ title: 'País', key: 'pais' }
			],
		}
	},

	created () {
        // this.carregaDados()
	},

	methods: {
		carregaDados(columnOrder, order, perPage, start){

			this.load = true

			var url = this._getUrl(`api/Local/${columnOrder}/${order}/${perPage}/${start}`)

			if(this.busca.trim() != ''){
				url += `/${this.busca}/${this.campoBusca}`
			}

			axios.get(url).then(response => {
				this.load = false

				 response.data.list = response.data.list.map(item => {
					 return this.geraColunas(item)
				 })

				 this.$refs.table.loadTable(response.data.list, response.data.qtd)
			})
		},

		geraColunas(item){

			let itemLista = {}
			let columns = []

			columns.push({ html: `${item.icao} <br/><small> ${item.nome} </small>` })
			columns.push({ html: item.iata })
			columns.push({ html: item.cidade })
			columns.push({ html: item.pais })


			columns.push({
				class: 'text-center',
				clickable: true,
				event: 'click-excluir',
				icon: ["far", "trash-alt"],
				styleIcon: 'font-size: 0.9rem',
				style: 'color: red'
			})

			columns.push({
				class: 'text-center',
				clickable: true,
				event: 'click-editar',
				icon: ["fa", "pen-alt"],
				styleIcon: 'font-size: 0.9rem',
			})

			itemLista._object = item
			itemLista.columns = columns
			return itemLista
		},

		geraCabecalhos(){

			let columns = []

			columns.push({
				name: 'Designativo - Aeroporto',
				key: 'icao',
				keyOrder: 'icao',
				sortable: true,
				width: '15%',
			})

			columns.push({
				name: 'IATA',
				key: 'iata',
				sortable: true,
				width: '5%',
			})

			columns.push({
				name: 'Cidade',
				key: 'cidade',
				sortable: true,
				width: '10%',
			})

			columns.push({
				name: 'País',
				key: 'pais',
				sortable: true,
				width: '10%',
			})

			columns.push({
				name: 'Excluir',
				key: 'excluir',
				sortable: false,
				class: 'text-center',
				width: '3%',
			})

			columns.push({
				name: 'Editar',
				key: 'editar',
				sortable: false,
				class: 'text-center',
				width: '3%',
			})

			return columns
		},

		clickModal(){

			this.exibeModalCadastro = true

			this.$nextTick(() => this.$refs.modalCadastro.show())

		},

		editar(item){
			this.exibeModalCadastro = true
			this.$refs.modalCadastro.show()

			this.$nextTick(() => {
				this.$refs.cadastro.editar(item._object)
			})
		},

		clickExcluir(item){
			let text = `<h4>Deseja excluir essa localidade ?</h4>
						<br>
						<p class="text-danger">${item._object.nome}</p>`

			this.$modalExcluir.show(text, item._object).then(item => {
				this.excluir(item)
			})
		},

		excluir(item){

            this.$notify.loadIn('Excluindo')

            axios.delete(this._getUrl('api/Local/' + item.id)).then(response => {
				this.$notify.show('success', 'Localidade excluída.')
				this.$refs.table.reseta()
            })
		},

		atualizar(item){
			this.$refs.table.reseta()

			this.$refs.modalCadastro.hide()
		},
	},
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/followair/local/main.vue